<template>
    <div id="mapDiv" style="height: 1px;width: 100%;" />
</template>
  
<script>
  export default {
    name: 'TiandiMap',
    data() {
        return {
            map: null,
            showRes: false,
            dataList: [],
            mapInfo: {},
            timer: null
        };
    },
    computed: {},
    mounted() {
        this.initMap();
        // 等待uniapp加载完成后发送信息
        document.addEventListener('UniAppJSBridgeReady', async function() {
            this.timer = setInterval(async()=>{
                if(this.mapInfo.city) {
                    clearInterval(this.timer);
                    // eslint-disable-next-line no-undef
                    uni.postMessage({
                        data: {
                            title: '天地图',
                            mapInfo: this.mapInfo
                        }
                    });
                }else{
                    this.getAddressZh(this.mapInfo.longitude, this.mapInfo.latitude)
                }
            }, 500)
        });
    },
    methods: {
        initMap() {
            this.map = new T.Map('mapDiv');
            const lnglat = new T.LngLat(116.40969,39.89945);
            this.map.centerAndZoom(lnglat, 12);
            this.getGeoLocation();
        },
        getAddressZh(lng, lat) {
            this.mapInfo = {
                ...this.mapInfo,
                longitude: lng,
                latitude: lat,
            }
            let geocoder = new T.Geocoder();
            geocoder.getLocation(new T.LngLat(lng, lat), (result) => {
                const addressComponent = result.getAddressComponent();
                this.mapInfo = {
                    ...this.mapInfo,
                    city: addressComponent.city,
                    address: result.getAddress()
                }
                // eslint-disable-next-line no-undef
                uni.postMessage({
                    data: {
                        title: '天地图',
                        mapInfo: this.mapInfo
                    }
                });
            });
        },
        getGeoLocation() {
            const lo = new T.Geolocation();
            const fn = function (e) {
                if (this.getStatus() == 0){
                    this.getAddressZh(e.lnglat.lng, e.lnglat.lat);

                }
                if(this.getStatus() == 1){
                    this.getAddressZh(e.lnglat.lng, e.lnglat.lat);
                }
            }
            lo.getCurrentPosition(fn);
        },
    }
  }
</script>
  
<style scoped>
.map {
    z-index: 1;
}
</style>
  